export const POPULATE = 'LandingZoneTagsPopulate'

export const SET_LOADED = 'LandingZoneTagsSetLoaded'

export const SET_FORMAT = 'LandingZoneTagsSetFormat'